import React, { useState, useEffect } from 'react';  
import { Document, Page, pdfjs } from 'react-pdf';  
  
pdfjs.GlobalWorkerOptions.workerSrc = new URL(  
    'pdfjs-dist/build/pdf.worker.min.mjs',  
    import.meta.url,  
).toString();  
  
export default function DocViewer({ link, downloadable }) {  
    const [numPages, setNumPages] = useState(null);  
    const [pageNumber, setPageNumber] = useState(null);  
  
    function onDocumentLoadSuccess({ numPages }) {  
        setNumPages(numPages);      
    }  
  
    useEffect(() => {  
        if (link && link.includes('#page=')) {  
            const pageFragment = link.split('#page=')[1];  
            const requestedPage = parseInt(pageFragment, 10);  
            if (requestedPage >= 1 && requestedPage <= numPages) {  
                setPageNumber(requestedPage);  
            }  
            else
            {
                setPageNumber(null);   
            }       
        } 
        else
        {
            setPageNumber(null);  
        } 
    }, [link, numPages]);  
  
    return (  
        <div   oncontextmenu="return false;" className="popover" onContextMenu={(e) => e.preventDefault()} onClick={(e)=>e.preventDefault()}>  
            <div className="popover-content">  
                <Document  
                    file={link}  
                    onLoadSuccess={onDocumentLoadSuccess}  
                >                  
                    {numPages && Array.from(new Array(numPages), (el, index) => (  
                        pageNumber !== null && pageNumber !== index + 1 ? null : (  
                            <Page  
                                key={`page_${index + 1}`}  
                                pageNumber={index + 1}  
                                width={window.innerWidth} // Fixed width value  
                            />  
                        )  
                    ))}  
                </Document>  
            </div>  
        </div>  
    );  
}  

//  --------------------- shree ram code below ----------------------

// export default function DocViewer({link, downloadable}){   
//     return (
//         <div oncontextmenu="return false;" className="popover">
//             <div className="popover-content">
//                {downloadable ? <iframe title="viewer" onMouseOver={(e)=>{e.stopPropagation();e.preventDefault()}} src={link} style={{ width: '100vw', height: '100vh', border: 'none' }} /> : 
//                 <iframe title="viewer" onMouseOver={(e)=>{e.stopPropagation();e.preventDefault()}} src={link&&link.indexOf("page=")>-1 ? link+"&toolbar=0": link+"#toolbar=0"} style={{ width: '100vw', height: '100vh', border: 'none' }} />
//                 } 
//             </div>
//         </div>
//     );
// }
